<template>
  <b-modal
    centered
    v-model="show"
    :title="modalData.title"
    :header-bg-variant="modalData.headerBgVariant"
    :header-text-variant="modalData.headerTextVariant"
    :body-bg-variant="bodyBgVariant"
    :body-text-variant="bodyTextVariant"
    :footer-bg-variant="footerBgVariant"
    :footer-text-variant="footerTextVariant"
  >
    {{ modalData.msg }}
    <template #modal-footer>
      <slot name="footer" />
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'tip-modal',
  props: ['tipData'],
  data () {
    return {
      show: false,
      modalData: {
        title: 'default title',
        msg: 'no msg',
        data: null,
        headerBgVariant: 'dark',
        headerTextVariant: 'light'
      },
      bodyBgVariant: 'light',
      bodyTextVariant: 'dark',
      footerBgVariant: 'light',
      footerTextVariant: 'dark'
    }
  },
  methods: {
    modalShow () {
      this.show = true
    },
    modalHide () {
      this.show = false
    }
  },
  watch: {
    tipData (val) {
      this.modalData = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TipModal.vue?3e0578b9